import React, { FC, ReactElement, useState } from 'react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import GoogleMapReact, { Coords } from 'google-map-react';
// Components
import MeetingPointPinComponent from './meetingPointPinComponent';
// Modules
import { MeetingPoint } from '../../core/apiTypes';
// Resources
import { getCustomMap, mapUtils, setCenter } from '../../utils/map';
import envConfig from '../../config/currentEnv';
import { useTheme } from '../../context/ThemeContext';

interface MeetingPointMapProps {
    children?: React.ReactNode;
    onApiLoaded?: (map, maps) => void;
    center?: Coords;
    zoom?: number;
    meetingPoint: MeetingPoint;
}

const MAP_HEIGHT = 300;

const MeetingPointMap: FC<MeetingPointMapProps> = (props): ReactElement => {
    const { children, center = mapUtils.defaultCenter, zoom = mapUtils.defaultZoom, onApiLoaded, meetingPoint } = props;
    const [googleMap, setMap] = useState(null);
    const { mode } = useTheme();

    React.useEffect(() => {
        if (googleMap?.map && googleMap?.maps) {
            googleMap.map.setZoom(zoom * 1.3);
            if (meetingPoint?.location) {
                setCenter(googleMap.map, meetingPoint.location);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [meetingPoint, googleMap]);

    const onGoogleReady = (map, maps) => {
        setMap({ map, maps });
        if (onApiLoaded) {
            onApiLoaded(map, maps);
        }
    };

    const classes = useStyles();

    return (
        <div className={classes.map}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: envConfig.currentEnv.googleMapKey }}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => onGoogleReady(map, maps)}
                // defaultCenter={center}
                center={center}
                // defaultZoom={zoom}
                zoom={zoom}
                options={{ fullscreenControl: false, zoomControl: false, styles: getCustomMap(mode) }}
            >
                {meetingPoint && googleMap && (
                    <MeetingPointPinComponent lat={meetingPoint.location.lat} lng={meetingPoint.location.lng} />
                )}
                {children}
            </GoogleMapReact>
        </div>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        map: {
            display: 'flex',
            width: '100%',
            height: MAP_HEIGHT,
            maxHeight: MAP_HEIGHT,
            minHeight: MAP_HEIGHT,
        },
    }),
);

export default MeetingPointMap;
